export const RecentSection = {
	general: 'general',
	pinned: 'pinned'
};

export const MessageStatus = {
	received: 'received',
	delivered: 'delivered',
	error: 'error'
};

export const RecentCallStatus = {
	waiting: 'waiting',
	joined: 'joined'
};

export const RecentSettings = {
	showBirthday: 'showBirthday',
	showInvited: 'showInvited',
	showLastMessage: 'showLastMessage'
};

// old chat names -> new model names
export const RecentSettingsMap = {
	'viewBirthday': 'showBirthday',
	'viewCommonUsers': 'showInvited',
	'viewLastMessage': 'showLastMessage'
};